import EventLayer from '@components/map/layers/event/EventLayer';
import FlightPlanLayer from '@components/map/layers/flightPlans/operational/FlightPlanLayer';
import { PlatformLayer } from '@components/map/layers/platforms/PlatformLayer';
import PoiLayer from '@components/map/layers/poi/PoiLayer';
import { StatisticLayer } from '@components/map/layers/statistics/StatisticLayer';

import ZoneLayer from './layers/zones/ZoneLayer';
import MapboxMap from './MapboxMap';

export function StatisticsMap() {
  return (
    <MapboxMap>
      <PlatformLayer />
      <ZoneLayer />
      <FlightPlanLayer />
      <PoiLayer />
      <EventLayer />
      <StatisticLayer />
    </MapboxMap>
  );
}
